(() => {
  class SizeGuideTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        return;
      }

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (this.tabs.length === 0 || this.panels.length === 0) {
        return;
      }

      this.dataset.initialized = 'true';

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event));
      });
    }

    activateTab(tab, moveFocus = false) {
      if (!this.tabs.includes(tab)) {
        return;
      }

      const panelId = tab.getAttribute('aria-controls');
      const activePanel = this.panels.find((panel) => panel.id === panelId);

      if (!activePanel) {
        return;
      }

      this.tabs.forEach((currentTab) => {
        const isActive = currentTab === tab;
        currentTab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        currentTab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel !== activePanel;
      });

      if (moveFocus) {
        tab.focus();
      }
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);

      if (currentIndex === -1) {
        return;
      }

      const isRtl = document.documentElement.dir === 'rtl';
      let nextIndex = currentIndex;

      switch (event.key) {
        case 'ArrowRight':
          nextIndex = isRtl ? currentIndex - 1 : currentIndex + 1;
          break;
        case 'ArrowLeft':
          nextIndex = isRtl ? currentIndex + 1 : currentIndex - 1;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
      this.activateTab(this.tabs[nextIndex], true);
    }
  }

  if (!customElements.get('size-guide-tabs')) {
    customElements.define('size-guide-tabs', SizeGuideTabs);
  }
})();
